import { useState, useEffect } from "react";
import api from '../config/api';

export default function EditStorageTransactionModal({ show, onClose, transaction, onSuccess }) {
  const [form, setForm] = useState({
    item_id: "",
    villa_id: "",
    quantity: "",
    transaction_type: "in",
    price_per_unit: "",
    supplier_name: "",
    description: "",
    updated_at: new Date().toISOString().slice(0, 16),
  });

  const [items, setItems] = useState([]);
  const [villas, setVillas] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  function parseJwt(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(window.atob(base64));
      return payload;
    } catch (e) {
      console.error("Failed to parse JWT:", e);
      return null;
    }
  }

  useEffect(() => {
    const fetchItems = async () => {
      const token = localStorage.getItem("token");
      const response = await fetch(api("/items"), {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setItems(data);
    };

    const fetchVillas = async () => {
      const token = localStorage.getItem("token");
      const response = await fetch(api("/villas"), {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setVillas(data);
    };

    fetchItems();
    fetchVillas();
  }, []);

  useEffect(() => {
    if (transaction) {
      setForm({
        item_id: transaction.item_id || "",
        villa_id: transaction.villa_id || "",
        quantity: transaction.quantity || "",
        transaction_type: transaction.transaction_type || "in",
        price_per_unit: transaction.price_per_unit || "",
        supplier_name: transaction.supplier_name || "",
        description: transaction.description || "",
        updated_at: transaction.updated_at ? transaction.updated_at.slice(0, 16) : new Date().toISOString().slice(0, 16),
      });
    }
  }, [transaction]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "price_per_unit") {
      const numericValue = Math.max(0, Number(value));
      setForm((prev) => ({ ...prev, [name]: numericValue }));
    } else if (name === "transaction_type") {
      const normalized = value.toLowerCase();
      if (normalized === "in" || normalized === "out") {
        setForm((prev) => ({ ...prev, [name]: normalized }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const decoded = parseJwt(token);
      const user_id = decoded?.user_id;

      const payload = {
        item_id: Number(form.item_id),
        user_id: user_id,            // <--- ini WAJIB ADA
        villa_id: form.villa_id ? Number(form.villa_id) : null,
        quantity: Number(form.quantity),
        transaction_type: form.transaction_type,
        price_per_unit: Number(form.price_per_unit),
        supplier_name: form.supplier_name,
        description: form.description,
        modified_by: user_id,
        updated_at: new Date(form.updated_at).toISOString(),
      };

      console.log(payload)

      const response = await fetch(api(`/storage-transactions/${transaction.id}`), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.error || "Failed to update transaction.");
        return;
      }

      alert("Storage transaction updated successfully!");
      setErrorMessage("");
      onClose();
      onSuccess();
    } catch (err) {
      console.error(err);
      setErrorMessage("Something went wrong. Please try again.");
    }
  };

  const handleClose = () => {
    const modal = document.querySelector(".fade-modal");
    if (modal) {
      modal.classList.remove("show");
      setTimeout(() => onClose(), 100);
    } else {
      onClose();
    }
    setErrorMessage("");
  };

  if (!show || !transaction) return null;

  return (
    <div className={`modal fade-modal ${show ? "show" : ""} d-block`} tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Storage Transaction</h5>
              <button type="button" className="btn-close" onClick={handleClose}></button>
            </div>
            <div className="modal-body">
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}
              <div className="row">
                {/* Left Side */}
                <div className="col-md-6">
                  {/* Item */}
                  <div className="mb-3">
                    <label className="form-label">Item</label>
                    <select
                      className="form-select"
                      name="item_id"
                      value={form.item_id}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Item --</option>
                      {items.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.code} - {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Villa */}
                  <div className="mb-3">
                    <label className="form-label">Villa (optional)</label>
                    <select
                      className="form-select"
                      name="villa_id"
                      value={form.villa_id}
                      onChange={handleChange}
                    >
                      <option value="">-- No Villa --</option>
                      {villas.map((villa) => (
                        <option key={villa.id} value={villa.id}>
                          {villa.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Quantity */}
                  <div className="mb-3">
                    <label className="form-label">Quantity</label>
                    <input
                      type="number"
                      className="form-control"
                      name="quantity"
                      value={form.quantity}
                      onChange={handleChange}
                      required
                      disabled
                    />
                  </div>
                  {/* Transaction Type */}
                  <div className="mb-3">
                    <label className="form-label">Transaction Type</label>
                    <select
                      className="form-select"
                      name="transaction_type"
                      value={form.transaction_type}
                      onChange={handleChange}
                      required
                      disabled
                    >
                      <option value="in">In</option>
                      <option value="out">Out</option>
                    </select>
                  </div>
                  {/* Transaction Date */}
                  <div className="mb-3">
                    <label className="form-label">Transaction Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="updated_at"
                      value={form.updated_at}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Right Side */}
                <div className="col-md-6">
                  {/* Price Per Unit */}
                  <div className="mb-3">
                    <label className="form-label">Price Per Unit</label>
                    <input
                      type="number"
                      className="form-control"
                      name="price_per_unit"
                      value={form.price_per_unit}
                      onChange={handleChange}
                      required
                      min="0"
                    />
                  </div>
                  {/* Supplier Name */}
                  <div className="mb-3">
                    <label className="form-label">Supplier Name</label>
                    <input
                      className="form-control"
                      name="supplier_name"
                      value={form.supplier_name}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Description */}
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={form.description}
                      onChange={handleChange}
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-cancel" type="button" onClick={handleClose}>
                Cancel
              </button>
              <button className="btn btn-submit" type="submit">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
